import { h } from '../lib/dom.js';
import { getState, setSilent } from '../store.js';
import { cancelOpenAccount, saveOpenAccount } from '../actions.js';
import { t } from '../i18n/index.js';

export function renderOpenAccountModal() {
  const s = getState();
  if (!s.showOpenAccount) return null;
  // modal-scrim-panel: desktop-only inline side panel instead of a
  // centered overlay (feature-ui.md's Desktop section) — see style.css.
  return h('div', { class: 'modal-scrim modal-scrim-panel' }, [
    h('div', { class: 'modal-card' }, [
      h('div', { class: 'modal-title' }, t('modals.openAccount.title')),
      h('input', {
        placeholder: t('modals.openAccount.namePlaceholder'), value: s.newAcctName,
        oninput: (e) => setSilent({ newAcctName: e.target.value }),
        onkeydown: (e) => { if (e.key === 'Enter') saveOpenAccount(); }
      }),
      h('input', {
        placeholder: t('modals.openAccount.ownerPlaceholder'), value: s.newAcctOwner,
        oninput: (e) => setSilent({ newAcctOwner: e.target.value }),
        onkeydown: (e) => { if (e.key === 'Enter') saveOpenAccount(); }
      }),
      h('div', { class: 'field-error' }, s.newAcctError || ''),
      h('div', { class: 'btn-row' }, [
        h('button', { class: 'btn btn-secondary', onclick: cancelOpenAccount }, t('common.cancel')),
        h('button', { class: 'btn btn-primary', onclick: saveOpenAccount }, t('modals.openAccount.open'))
      ])
    ])
  ]);
}
